import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Radar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import isAuthenticated from "../../../components/Utils/isAuthenticated";
import { getSpotReportDataMultiDownload } from "../../../components/Api/Getters";
import { spread } from "axios";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

var responses = "something";

export const generateOptions = () => {
	return {
		// responsive: true,
		plugins: {
			datalabels: {
				anchor: "start",
				align: "start",
				// color: 'black',
				// font: {
				// 	// size: 16,
				//   	weight: 'bold'
				// },
				formatter: function (value, context) {
					let array = ["SD", "D", "N", "A", "SA"];
					return array[context.datasetIndex];
				},
			},

			legend: {
				display: false,
				position: "bottom",
				labels: {
					font: {
						size: 16,
					},
				},
			},
			title: {
				display: true,
				text: ["SPOT Frequency Distributions", responses],
				font: {
					size: 22,
				},
			},
		},
		scales: {
			y: {
				ticks: {
					font: {
						size: 16, // Set the desired font size for y-axis labels
					},
				},
				grid: {
					color: "#A9A9A9",
				},
			},
			x: {
				ticks: {
					font: {
						size: 16, // Set the desired font size for y-axis labels
					},
					padding: 20,
				},
				grid: {
					color: "#A9A9A9",
				},
			},
		},
	};
};

function calculatePercentage(value, total) {
	// Check if both parameters are numbers
	if (typeof value !== "number" || typeof total !== "number") {
		return "0.0%";
	}

	// Calculate the percentage and round it to one decimal place
	const percentage = (value / total) * 100;
	const roundedPercentage = percentage.toFixed(1);

	// Format the result as a percentage string
	return `${roundedPercentage}%`;
}

function createData(category, question, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor) {
	return { category, question, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor };
}

function createCustomeData(category, question, rsp1, rsp2, rsp3, rsp4, rsp5, scale) {
	return { category, question, rsp1, rsp2, rsp3, rsp4, rsp5, scale };
}

const colours = {
	Design: [235, 235, 235],
	"Utility of Course Resources": [255, 255, 255],
	"Graded Work": [235, 235, 235],
	"Course Delivery": [255, 255, 255],
	"Instructional Approach": [235, 235, 235],
	"Class Climate": [255, 255, 255],
};

async function collect_report_data(token, reports) {
	const apiData = await getSpotReportDataMultiDownload(token, reports);

	let spot_data = [];
	for (let index = 0; index < apiData.length; index++) {
		let spot_entry = {};
		let req_info = [
			apiData[index].req_info.ctitle,
			apiData[index].req_info.inst,
			apiData[index].req_info.term,
			apiData[index].req_info.faculty,
			apiData[index].req_info.dept,
			apiData[index].req_info.reqnum,
			apiData[index].req_info.clsnum,
			apiData[index].req_info.csize,
			apiData[index].req_info.qtally,
			,
			apiData[index].req_info.empid,
		];

		let question_data = [];
		if (apiData[index].req_info.questions.length > 0) {
			let unformated_data = apiData[index].req_info.questions.split("|~^~|");
			// Parse and format question data.
			for (let i = 0; i < unformated_data.length; i++) {
				let entry = unformated_data[i].slice(1, -1).split("|~|");
				entry = createData(
					entry[0].trim(),
					entry[2].trim(),
					entry[3].trim(),
					entry[4].trim(),
					entry[5].trim(),
					entry[6].trim(),
					entry[7].trim(),
					colours[entry[0].trim()],
				);
				question_data.push(entry);
			}
		}
		spot_entry["req_info"] = [req_info, question_data];

		question_data = [];
		if (apiData[index].customSpotData.questions.length > 0) {
			let unformated_data = apiData[index].customSpotData.questions.split("|~^~|");
			// Parse and format question data.
			for (let i = 0; i < unformated_data.length; i++) {
				let entry = unformated_data[i].slice(1, -1).split("|~|");
				entry = createCustomeData(
					entry[0].trim(),
					entry[2].trim(),
					entry[3].trim(),
					entry[4].trim(),
					entry[5].trim(),
					entry[6].trim(),
					entry[7].trim(),
					entry[8].trim().split(";"),
				);
				question_data.push(entry);
			}
		}
		spot_entry["customSpotData"] = question_data;
		spot_entry["comments"] = apiData[index].comments;
		spot_data.push(spot_entry);
	}
	return spot_data;
}

// async function fetchData(url) {
// 	const response = await fetch(url, {
// 		headers: { Authorization: `Token ${sessionStorage.token}` },
// 	});
// 	const data = await response.json();
// 	return data;
// }

// async function numericalData(reqID) {
// 	const url = `${process.env.REACT_APP_BACKEND_HOST}/spot/spot_data/${reqID}/`;
// 	const apiData = await fetchData(url);

// 	let req_info = [
// 		apiData.ctitle,
// 		apiData.inst,
// 		apiData.term,
// 		apiData.faculty,
// 		apiData.dept,
// 		apiData.reqnum,
// 		apiData.clsnum,
// 		apiData.csize,
// 		apiData.qtally,
// 	];

// 	let question_data = [];
// 	if (apiData.questions.length > 0) {
// 		let unformated_data = apiData.questions.split("|~^~|");
// 		// Parse and format question data.
// 		for (let i = 0; i < unformated_data.length; i++) {
// 			let entry = unformated_data[i].slice(1, -1).split("|~|");
// 			entry = createData(
// 				entry[0].trim(),
// 				entry[2].trim(),
// 				entry[3].trim(),
// 				entry[4].trim(),
// 				entry[5].trim(),
// 				entry[6].trim(),
// 				entry[7].trim(),
// 				colours[entry[0].trim()]
// 			);
// 			question_data.push(entry);
// 		}
// 	}
// 	return [req_info, question_data];
// }

// async function SuppData(reqID) {
// 	const url = `${process.env.REACT_APP_BACKEND_HOST}/spot/custom_spot_data/${reqID}/`;
// 	const apiData = await fetchData(url);
// 	let question_data = [];
// 	if (apiData.questions.length > 0) {
// 		let unformated_data = apiData.questions.split("|~^~|");
// 		// Parse and format question data.
// 		for (let i = 0; i < unformated_data.length; i++) {
// 			let entry = unformated_data[i].slice(1, -1).split("|~|");
// 			entry = createCustomeData(
// 				entry[0].trim(),
// 				entry[2].trim(),
// 				entry[3].trim(),
// 				entry[4].trim(),
// 				entry[5].trim(),
// 				entry[6].trim(),
// 				entry[7].trim(),
// 				entry[8].trim().split(";")
// 			);
// 			question_data.push(entry);
// 		}
// 	}
// 	return question_data;
// }

// async function commentsData(reqID) {
// 	const url = `${process.env.REACT_APP_BACKEND_HOST}/spot/spot_comments/${reqID}/`;
// 	const commentData = await fetchData(url);
// 	return commentData;
// }

const getRowSpan = (data, index) => {
	let count = 1;
	while (index + count < data.length && data[index].category === data[index + count].category) {
		count++;
	}
	return count;
};

async function pdfHeader(pdf, data) {
	pdf.setFont("helvetica", "bold");
	pdf.setFontSize(16);
	pdf.text("Student Perspectives of Teaching (SPOT)", 14, 10);

	pdf.setFont("helvetica", "normal");
	pdf.setFontSize(8);
	pdf.text(data[3], 14, 14);
	pdf.text(data[4], 14, 18);
	const string = "Number of students responding to questionnaire: ".concat(
		data[8],
		" of ",
		data[7],
		" (",
		calculatePercentage(data[8], data[7]),
		")",
	);
	pdf.text(string, 14, 22);

	pdf.setFont("helvetica", "normal");
	pdf.text("Term:       ", 235, 10);
	pdf.text("Class:      ", 235, 14);
	pdf.text("Instructor: ", 235, 18);
	pdf.text("Reqnum:     ", 235, 22);

	pdf.setFont("helvetica", "bold");
	pdf.text(data[2], 250, 10);
	pdf.text(data[0], 250, 14);
	pdf.text(data[1], 250, 18);
	pdf.text(data[5].concat("-", data[6]), 250, 22);
	pdf.line(14, 25, 283, 25);
}

async function pdfFooter(pdf) {
	pdf.setFont("helvetica", "italic");
	pdf.setFontSize(7.5);
	pdf.text(
		"Student surveys are an important part of providing feedback about their perspectives of teaching, but cannot be taken in isolation as a complete evaluation of a course or instructor. Factors outside of an instructor’s control may",
		16,
		// 175
		183,
	);
	pdf.text(
		"influence the results. These factors include, but are not limited to:",
		16,
		// 178
		186,
	);
	pdf.text("a. completion rate of the survey;", 26, 190);
	pdf.text(
		"b. class size, class level, the Faculty and program in which the course is developed, timing of the class, delivery mode, required versus optional course, accredited program requirements, practicum or clinical contexts,",
		26,
		// 187
		195,
	);
	pdf.text(
		"grade expectations, student GPA, age of both students and instructors; and,",
		29,
		// 190
		198,
	);
	pdf.text(
		"c. perceived race, gender, age, religion, ability, sexual orientation, and/or ethnicity of the instructor.",
		26,
		// 193
		201,
	);
	pdf.text(
		"Small differences in results should not be considered meaningful. Results will be interpreted using the defined scale: Strongly Disagree (SD); Disagree (D); Neither Agree nor Disagree (N); Agree (A); and, Strongly Agree (SA).",
		16,
		// 199
		207,
	);
}

async function standardTable(pdf, req_info, data) {
	await pdfHeader(pdf, req_info);
	const bodyContent = [];

	data.forEach((row, index) => {
		let entry = [];
		if (index === 0 || row.category !== data[index - 1].category) {
			// Add a cell with rowSpan if it's the first row of a category
			entry.push({
				content: row.category,
				rowSpan: getRowSpan(data, index),
				styles: {
					valign: "middle",
					halign: "center",
					fontSize: 8,
					fillColor: colours[row.category],
					textColor: "black",
				}, // Set font size here
			});
		}
		entry.push(
			{
				content: row.question,
				styles: {
					fontSize: 8,
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp1,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp2,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp3,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp4,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp5,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
		);
		bodyContent.push(entry);
	});

	const columnHeaders = [
		{
			content: "SPOT DOMAIN",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Question",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Strongly Disagree",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Disagree",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Neither Agree Nor Disagree",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Agree",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Strongly Agree",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
	];

	autoTable(pdf, {
		head: [columnHeaders],
		headStyles: { fillColor: [39, 93, 56], lineWidth: 0.2 },
		columnStyles: {
			0: { cellWidth: 27 },
			1: { cellWidth: 92 },
			2: { cellWidth: 30 },
			3: { cellWidth: 30 },
			4: { cellWidth: 30 },
			5: { cellWidth: 30 },
			6: { cellWidth: 30 },
		},
		body: bodyContent,
		startY: 28,
		theme: "grid",
	});
	pdfFooter(pdf);
	pdf.addPage();
}

async function supplementaryTable(pdf, req_info, data) {
	await pdfHeader(pdf, req_info);
	function arraysAreEqual(arr1, arr2) {
		if (arr1.length !== arr2.length) {
			return false;
		}

		for (let i = 0; i < arr1.length; i++) {
			if (arr1[i] !== arr2[i]) {
				return false;
			}
		}

		return true;
	}

	const organized_data = [];
	for (let i = 0; i < data.length; i++) {
		let inserted = false;

		for (let j = 0; j < organized_data.length; j++) {
			if (
				organized_data[j][0].category === data[i].category &&
				arraysAreEqual(organized_data[j][0].scale, data[i].scale)
			) {
				organized_data[j].push(data[i]);
				inserted = true;
				break;
			}
		}

		if (!inserted) {
			organized_data.push([data[i]]);
		}
	}

	let startHeight = 28;
	organized_data.forEach((data, index) => {
		let addedHeight = 0;
		const bodyContent = [];
		data.forEach((row, index) => {
			let entry = [];
			if (index === 0 || row.category !== data[index - 1].category) {
				entry.push({
					content: row.category,
					rowSpan: getRowSpan(data, index),
					styles: {
						valign: "middle",
						halign: "center",
						fontSize: 8,
						textColor: "black",
					},
				});
			}
			addedHeight = addedHeight + 7 + (Math.ceil(row.question.length / 71) - 1) * 3;

			entry.push(
				{ content: row.question, styles: { fontSize: 8, textColor: "black" } },
				{
					content: row.rsp1,
					styles: { fontSize: 8, halign: "center", textColor: "black" },
				},
				{
					content: row.rsp2,
					styles: { fontSize: 8, halign: "center", textColor: "black" },
				},
				{
					content: row.rsp3,
					styles: { fontSize: 8, halign: "center", textColor: "black" },
				},
				{
					content: row.rsp4,
					styles: { fontSize: 8, halign: "center", textColor: "black" },
				},
				{
					content: row.rsp5,
					styles: { fontSize: 8, halign: "center", textColor: "black" },
				},
			);
			bodyContent.push(entry);
		});

		const columnHeaders = [
			{
				content: "SPOT DOMAIN",
				styles: { fontSize: 8, halign: "center", valign: "middle" },
			},
			{
				content: "Question",
				styles: { fontSize: 8, halign: "center", valign: "middle" },
			},
		];
		for (let i = 0; i < data[0].scale.length; i++) {
			columnHeaders.push({
				content: data[0].scale[i],
				styles: { fontSize: 8, halign: "center", valign: "middle" },
			});
		}
		if (startHeight + 10 + addedHeight + 5 <= 190) {
			autoTable(pdf, {
				head: [columnHeaders],
				headStyles: { fillColor: [39, 93, 56], lineWidth: 0.2 },
				columnStyles: {
					0: { cellWidth: 27 },
					1: { cellWidth: 92 },
					2: { cellWidth: 30 },
					3: { cellWidth: 30 },
					4: { cellWidth: 30 },
					5: { cellWidth: 30 },
					6: { cellWidth: 30 },
				},
				body: bodyContent,
				startY: startHeight,
				theme: "grid",
			});
		} else {
			pdf.addPage();
			pdfHeader(pdf, req_info);
			startHeight = 28;

			autoTable(pdf, {
				head: [columnHeaders],
				headStyles: { fillColor: [39, 93, 56], lineWidth: 0.2 },
				columnStyles: {
					0: { cellWidth: 27 },
					1: { cellWidth: 92 },
					2: { cellWidth: 30 },
					3: { cellWidth: 30 },
					4: { cellWidth: 30 },
					5: { cellWidth: 30 },
					6: { cellWidth: 30 },
				},
				body: bodyContent,
				startY: startHeight,
				theme: "grid",
			});
		}
		startHeight = startHeight + 10 + addedHeight + 5;
	});
	pdf.addPage();
}

async function summaryTable(pdf, req_info, data) {
	await pdfHeader(pdf, req_info);
	function createData(category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor) {
		return { category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor };
	}

	function summarizeData(data) {
		const summary = data.reduce((acc, row) => {
			if (row.category in acc) {
				acc[row.category][0] += Number(row.rsp1);
				acc[row.category][1] += Number(row.rsp2);
				acc[row.category][2] += Number(row.rsp3);
				acc[row.category][3] += Number(row.rsp4);
				acc[row.category][4] += Number(row.rsp5);
			} else {
				acc[row.category] = [
					Number(row.rsp1),
					Number(row.rsp2),
					Number(row.rsp3),
					Number(row.rsp4),
					Number(row.rsp5),
					row.backgroundColor,
				];
			}
			return acc;
		}, {});

		const output = Object.keys(summary).map((key) => {
			const [rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor] = summary[key];
			return createData(key, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor);
		});

		return output;
	}
	const summaryData = summarizeData(data);
	const bodyContent = [];

	summaryData.forEach((row, index) => {
		let entry = [];
		if (index === 0 || row.category !== data[index - 1].category) {
			// Add a cell with rowSpan if it's the first row of a category
			entry.push({
				content: row.category,
				styles: {
					valign: "middle",
					halign: "center",
					fontSize: 8,
					fillColor: colours[row.category],
					textColor: "black",
				},
			});
		}
		entry.push(
			{
				content: row.rsp1,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp2,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp3,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp4,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
			{
				content: row.rsp5,
				styles: {
					fontSize: 8,
					halign: "center",
					fillColor: colours[row.category],
					textColor: "black",
				},
			},
		);
		bodyContent.push(entry);
	});

	const columnHeaders = [
		{
			content: "SPOT DOMAIN",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Strongly Disagree (SD)",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Disagree (D)",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Neither Agree Nor Disagree (N)",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Agree (A)",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
		{
			content: "Strongly Agree (SA)",
			styles: { fontSize: 8, halign: "center", valign: "middle" },
		},
	];

	autoTable(pdf, {
		head: [columnHeaders],
		headStyles: { fillColor: [39, 93, 56], lineWidth: 0.2 },
		columnStyles: {
			0: { cellWidth: 49 },
			1: { cellWidth: 44 },
			2: { cellWidth: 44 },
			3: { cellWidth: 44 },
			4: { cellWidth: 44 },
			5: { cellWidth: 44 },
		},
		body: bodyContent,
		startY: 28,
		theme: "grid",
	});
	// pdf.addPage();
}

async function summaryChart(pdf, req_info, data) {
	responses = "Responses : ".concat(
		req_info[8],
		" of ",
		req_info[7],
		" (",
		calculatePercentage(req_info[8], req_info[7]),
		")",
	);
	const options = generateOptions();
	const colors = {
		"Strongly Disagree": "rgba(231,64,53,255)", //red
		Disagree: "rgba(253,109,0,255)", //orange
		"Neither Agree Nor Disagree": "rgba(248,190,0,255)", //yellow
		Agree: "rgba(0,192,187,255)", //SKY BLUE:'rgba(10,184,233,255)', //blue
		"Strongly Agree": "rgba(48,169,85,255)", //green
	};

	function createData(category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor) {
		return { category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor };
	}

	async function summarizeData(data) {
		const summary = data.reduce((acc, row) => {
			if (row.category in acc) {
				acc[row.category][0] += Number(row.rsp1);
				acc[row.category][1] += Number(row.rsp2);
				acc[row.category][2] += Number(row.rsp3);
				acc[row.category][3] += Number(row.rsp4);
				acc[row.category][4] += Number(row.rsp5);
			} else {
				acc[row.category] = [
					Number(row.rsp1),
					Number(row.rsp2),
					Number(row.rsp3),
					Number(row.rsp4),
					Number(row.rsp5),
					row.backgroundColor,
				];
			}
			return acc;
		}, {});

		const output = Object.keys(summary).map((key) => {
			const [rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor] = summary[key];
			return createData(key, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor);
		});

		return output;
	}

	function getCategories(spotData) {
		const categories = spotData.map((item) => item.category);
		const uniqueCategoriesSet = new Set(categories);
		const uniqueCategories = [...uniqueCategoriesSet];
		return uniqueCategories;
	}

	async function collectData(spotData) {
		let responses = [
			"Strongly Disagree",
			"Disagree",
			"Neither Agree Nor Disagree",
			"Agree",
			"Strongly Agree",
		];
		let data = { labels: getCategories(spotData), datasets: [] };
		for (let i = 0; i < responses.length; i++) {
			let entry = {
				label: responses[i],
				data: [],
				backgroundColor: colors[responses[i]],
			};
			data.datasets.push(entry);
		}

		for (let i = 0; i < spotData.length; i++) {
			let entry = [
				spotData[i].rsp1,
				spotData[i].rsp2,
				spotData[i].rsp3,
				spotData[i].rsp4,
				spotData[i].rsp5,
			];
			for (let j = 0; j < entry.length; j++) {
				data.datasets[j].data.push(entry[j]);
			}
		}
		return data;
	}

	const chartData = await collectData(await summarizeData(data));

	const summaryChart = (
		<div>
			<Bar options={options} data={chartData} height={70} />
		</div>
	);

	const container = document.createElement("div");
	document.body.appendChild(container);
	ReactDOM.render(summaryChart, container);

	await new Promise((resolve) => setTimeout(resolve, 1000));

	await html2canvas(container, { scale: 2 }).then(function (canvas) {
		const imgData = canvas.toDataURL("image/jpeg", 1);
		const pdfWidth = pdf.internal.pageSize.getWidth();
		const pdfHeight = pdf.internal.pageSize.getHeight() * 0.45;
		const contentWidth = pdfWidth - 24;
		const contentHeight = pdfHeight - 30;

		pdf.addImage(imgData, "JPEG", 10, 85, contentWidth, contentHeight);
		pdf.addPage();

		// Clean up: Unmount and remove the temporary container
		ReactDOM.unmountComponentAtNode(container);
		// root.unmount()
		document.body.removeChild(container);
	});
}

async function radarChart(pdf, req_info, radarData) {
	await pdfHeader(pdf, req_info[0]);

	function createSummaryData(category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor) {
		return { category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor };
	}

	function summarizeData(data) {
		const summary = data.reduce((acc, row) => {
			if (row.category in acc) {
				// Aggregate response values for existing category.
				acc[row.category][0] += Number(row.rsp1);
				acc[row.category][1] += Number(row.rsp2);
				acc[row.category][2] += Number(row.rsp3);
				acc[row.category][3] += Number(row.rsp4);
				acc[row.category][4] += Number(row.rsp5);
			} else {
				// Create a new category entry with aggregated response values.
				acc[row.category] = [
					Number(row.rsp1),
					Number(row.rsp2),
					Number(row.rsp3),
					Number(row.rsp4),
					Number(row.rsp5),
					row.backgroundColor,
				];
			}
			return acc;
		}, {});

		// Convert the summarized data into an array of summary objects.
		const output = Object.keys(summary).map((key) => {
			const [rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor] = summary[key];
			return createSummaryData(key, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor);
		});

		return output;
	}

	function calculateStats(responseArray) {
		return responseArray.map((item) => {
			const frequencies = [1, 2, 3, 4, 5].map((i) => item[`rsp${i}`] || 0);
			const total = frequencies.reduce((a, b) => a + b, 0);

			if (total === 0) {
				return {
					category: item.category,
					median: null,
				};
			}

			const medianPos = total / 2;
			let cumulative = 0;
			let median = null;

			for (let i = 0; i < frequencies.length; i++) {
				const f = frequencies[i];
				cumulative += f;

				if (cumulative >= medianPos) {
					const F = cumulative - f; // cumulative before this category
					const L = i + 1 - 0.5; // lower boundary: 0.5, 1.5, 2.5, 3.5, 4.5
					const w = 1; // bin width

					median = L + ((medianPos - F) / f) * w;
					break;
				}
			}

			// Safety clamp (shouldn’t really fire, but harmless)
			median = Math.min(median, 5);
			median = parseFloat(median.toFixed(1)); // or 1 decimal if you prefer

			return {
				category: item.category,
				median,
			};
		});
	}
	if (radarData === null) {
		const spotData = summarizeData(req_info[1]);
		const stats = await calculateStats(summarizeData(req_info[1]));
		radarData = {
			labels: stats.map((stat) => stat.category),
			datasets: [
				{
					label: `${req_info[0][2]} - ${req_info[0][0]}`,
					data: stats.map((stat) => stat.median),
					// backgroundColor: 'rgba(39, 93, 56, 0.2)',
					backgroundColor: "rgba(39, 93, 56, 0.1)",
					borderColor: "rgba(39, 93, 56, 1)",
					borderWidth: 2,
					pointBackgroundColor: "rgba(39, 93, 56, 1)",
				},
			],
		};
	}

	// --- 1) Define your content box in mm (landscape A4: 297 x 210 mm) ---
	const pageW = pdf.internal.pageSize.getWidth(); // 297
	const pageH = pdf.internal.pageSize.getHeight(); // 210

	// Match your header/footer spacing. You draw a header to y=25 and start at 28 elsewhere.
	const marginLeft = 20; // mm
	const marginRight = 20; // mm
	const topAfterHeader = 28; // mm (below the header line you draw)
	const marginBottom = 20; // mm

	const boxWmm = pageW - marginLeft - marginRight;
	const boxHmm = pageH - topAfterHeader - marginBottom;

	// --- 2) Convert mm -> CSS pixels so the canvas matches the PDF box exactly ---
	const QUALITY = 1.25;

	// instead of 96 px per inch, simulate 192 px per inch
	const PX_PER_MM = (96 * QUALITY) / 25.4;
	const boxWpx = Math.round(boxWmm * PX_PER_MM);
	const boxHpx = Math.round(boxHmm * PX_PER_MM);

	// --- 3) Chart options (same as yours, just ensure no vh-based sizing) ---
	const medians = radarData.datasets.flatMap((d) => d.data);
	const minMedian = Math.min(...medians);
	let radarChartMin = 1;
	if (minMedian >= 4) radarChartMin = 3;

	const radarOptions = {
		responsive: true,
		maintainAspectRatio: false, // we control the container’s size
		animation: false, // avoids timing issues before snapshot
		elements: { point: { radius: 3, hoverRadius: 6, borderWidth: 3, hitRadius: 10 } },
		plugins: {
			legend: { position: "bottom", labels: { padding: 10, font: { size: 12 } } },
			title: {
				display: true,
				text: "SPOT Domain Analysis (Interpolated Medians)",
				font: { size: 20, weight: "normal" },
				color: "black",
				padding: { bottom: 20 },
			},
			datalabels: {
				display: (ctx) => ctx?.chart?.data?.datasets?.length === 1,
				color: "black",
				font: { size: 14, weight: "bold" },
				anchor: "end",
				align: "start",
				offset: 8,
				formatter: (value) =>
					value == null || Number.isNaN(value) ? "" : Number(value).toFixed(1),
			},
			centerMinLabel: {
				formatter: (minValue, scale) => (scale.min === 3 ? "1–3" : String(minValue)),
			},
		},
		scales: {
			r: {
				min: radarChartMin,
				max: 5,
				ticks: {
					stepSize: 1,
					color: "black",
					font: { size: 14, weight: "bold" },
					callback: (value) =>
						radarChartMin === 3 ? ([4, 5].includes(value) ? String(value) : "") : String(value),
				},
				pointLabels: { color: "black", font: { size: 14 } },
				grid: { color: "#aaaaaa" },
				angleLines: { color: "#aaaaaa" },
			},
		},
	};

	// --- 4) Create a fixed-size container DIV in pixels ---
	const container = document.createElement("div");
	container.style.position = "fixed";
	container.style.left = "-10000px"; // keep it off-screen
	container.style.top = "0";
	container.style.width = `${boxWpx}px`;
	container.style.height = `${boxHpx}px`;
	container.style.background = "white"; // ensure non-transparent background
	document.body.appendChild(container);

	// Render the Radar into the fixed-size container
	const chartNode = (
		<div style={{ width: `${boxWpx}px`, height: `${boxHpx}px` }}>
			<Radar data={radarData} options={radarOptions} />
		</div>
	);
	ReactDOM.render(chartNode, container);

	// Let layout settle
	await new Promise((r) => setTimeout(r, 1000));

	// --- 5) Snapshot at 1:1 CSS pixel size with html2canvas ---
	const canvas = await html2canvas(container, {
		backgroundColor: "#ffffff",
		scale: 1, // 1 CSS pixel = 1 canvas pixel (we already sized the container)
		useCORS: true,
		logging: false,
	});

	// --- 6) Add the image to PDF, fitting within the mm box and preserving aspect ---
	const imgData = canvas.toDataURL("image/jpeg", 1);
	const props = pdf.getImageProperties(imgData);
	const imgWmmAt1 = props.width / PX_PER_MM;
	const imgHmmAt1 = props.height / PX_PER_MM;
	const imgAspect = imgWmmAt1 / imgHmmAt1;
	const boxAspect = boxWmm / boxHmm;

	let drawWmm, drawHmm;
	if (imgAspect > boxAspect) {
		// Image is wider than the box -> limit by width
		drawWmm = boxWmm;
		drawHmm = drawWmm / imgAspect;
	} else {
		// Image is taller -> limit by height
		drawHmm = boxHmm;
		drawWmm = drawHmm * imgAspect;
	}

	// Center it within the box
	const x = marginLeft + (boxWmm - drawWmm) / 2;
	const y = topAfterHeader + (boxHmm - drawHmm) / 2;

	pdf.addImage(imgData, "JPEG", x, y, drawWmm, drawHmm);

	// Optional: new page after radar
	pdf.addPage();

	// --- 7) Clean up ---
	ReactDOM.unmountComponentAtNode(container);
	document.body.removeChild(container);
}

async function trendChart(pdf, req_info, trendComparison, domain, index) {
	if (index % 2 === 0) {
		await pdfHeader(pdf, req_info[0]);
	}

	// ---------- utilities ----------
	const pct = (num, den) => (den ? +((num / den) * 100).toFixed(1) : 0);

	async function fetchJSON(url, options) {
		const res = await fetch(url, options);
		if (!res.ok) {
			const text = await res.text().catch(() => "");
			throw new Error(`HTTP ${res.status} for ${url} – ${text || "no response body"}`);
		}
		return res.json();
	}

	// ---------- APIs ----------
	async function fetchTermsList() {
		const url = process.env.REACT_APP_BACKEND_HOST + "/spot/terms_list/";
		const json = await fetchJSON(url, {
			method: "GET",
			headers: {
				Authorization: `Token ${sessionStorage.token}`,
				"Content-Type": "application/json",
			},
		});
		// Ensure array, then sort by numeric `term` ascending
		const list = Array.isArray(json) ? json : [];
		return list.sort((a, b) => (a?.term ?? 0) - (b?.term ?? 0));
	}

	async function fetchComparisonData(req_info_local) {
		const masterRecord = `${req_info_local[0][5]}_${req_info_local[0][6]}`; // REQNUM_CLSNUM
		const empids = sessionStorage.getItem("id");
		const url = process.env.REACT_APP_BACKEND_HOST + "/spot/radar_data/";

		const json = await fetchJSON(url, {
			method: "POST",
			headers: {
				Authorization: `Token ${sessionStorage.token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ empids }),
		});

		// Build object keyed by REQNUM_CLSNUM, then collapse to array
		const byClass = {};
		for (const item of json || []) {
			const arrayId = `${item.REQNUM}_${item.CLSNUM}`;
			if (arrayId === masterRecord) continue;

			const row = {
				category: item.CAT_NAME,
				rsp1: +item.RSP1 || 0,
				rsp2: +item.RSP2 || 0,
				rsp3: +item.RSP3 || 0,
				rsp4: +item.RSP4 || 0,
				rsp5: +item.RSP5 || 0,
			};

			if (!byClass[arrayId]) {
				byClass[arrayId] = {
					id: arrayId,
					term: String(item.DESC_TERM || "").trim(), // e.g., "Winter 2025"
					course: String(item.CTITLE || "").trim(), // e.g., "PHYSL 210B LEC C01"
					questions: [row],
				};
			} else {
				byClass[arrayId].questions.push(row);
			}
		}

		// Summarize questions (aggregate by category per class)
		const summarized = Object.values(byClass).map((entry) => ({
			...entry,
			questions: summarizeData(entry.questions),
		}));

		return summarized;
	}

	// ---------- summarization helpers ----------
	function summarizeData(rows) {
		// Accumulate rsp1..rsp5 totals per category
		const acc = new Map();
		for (const r of rows || []) {
			const key = r.category;
			if (!key) continue;
			const prev = acc.get(key) || [0, 0, 0, 0, 0];
			acc.set(key, [
				prev[0] + (+r.rsp1 || 0),
				prev[1] + (+r.rsp2 || 0),
				prev[2] + (+r.rsp3 || 0),
				prev[3] + (+r.rsp4 || 0),
				prev[4] + (+r.rsp5 || 0),
			]);
		}
		// Convert back to array of {category, rsp1..rsp5}
		return Array.from(acc.entries()).map(([category, [rsp1, rsp2, rsp3, rsp4, rsp5]]) => ({
			category,
			rsp1,
			rsp2,
			rsp3,
			rsp4,
			rsp5,
		}));
	}

	// Aggregate base (master) course data by category → disagree/neutral/agree
	function buildDefaultDomainDataset(reqInfoRows, domain) {
		// req_info[1] is question rows for the master record
		const summarized = summarizeData(reqInfoRows);
		const sums = summarized.reduce(
			(acc, r) => {
				if (r.category !== domain) return acc;
				acc.disagree += (r.rsp1 || 0) + (r.rsp2 || 0);
				acc.neutral += r.rsp3 || 0;
				acc.agree += (r.rsp4 || 0) + (r.rsp5 || 0);
				acc.total += (r.rsp1 || 0) + (r.rsp2 || 0) + (r.rsp3 || 0) + (r.rsp4 || 0) + (r.rsp5 || 0);
				return acc;
			},
			{ disagree: 0, neutral: 0, agree: 0, total: 0 },
		);

		const disagreePct = pct(sums.disagree, sums.total);
		const neutralPct = pct(sums.neutral, sums.total);
		const agreePct = pct(sums.agree, sums.total);

		return {
			labels: [[`${req_info[0][0]}`, `${req_info[0][2]}`]], // [[course, term]]
			datasets: [
				{
					label: "Disagree (SD/D)",
					data: [disagreePct],
					fill: false,
					backgroundColor: "rgba(230, 23, 23, 1)",
					borderColor: "rgba(230, 23, 23, 1)",
				},
				{
					label: "Neutral (N)",
					data: [neutralPct],
					fill: false,
					backgroundColor: "rgba(255, 182, 0, 1)",
					borderColor: "rgba(255, 182, 0, 1)",
				},
				{
					label: "Agree (A/SA)",
					data: [agreePct],
					fill: false,
					backgroundColor: "rgba(39, 93, 56, 1)",
					borderColor: "rgba(39, 93, 56, 1)",
				},
			],
		};
	}

	// Add comparison rows to the base dataset for one domain
	function calculateTrendStats(base, comparisonRows, domain) {
		const out = {
			labels: [...base.labels],
			datasets: base.datasets.map((ds) => ({ ...ds, data: [...ds.data] })),
		};

		for (const cls of comparisonRows || []) {
			const sums = (cls.questions || []).reduce(
				(acc, r) => {
					if (r.category !== domain) return acc;
					acc.disagree += (r.rsp1 || 0) + (r.rsp2 || 0);
					acc.neutral += r.rsp3 || 0;
					acc.agree += (r.rsp4 || 0) + (r.rsp5 || 0);
					acc.total +=
						(r.rsp1 || 0) + (r.rsp2 || 0) + (r.rsp3 || 0) + (r.rsp4 || 0) + (r.rsp5 || 0);
					return acc;
				},
				{ disagree: 0, neutral: 0, agree: 0, total: 0 },
			);

			out.datasets[0].data.push(pct(sums.disagree, sums.total));
			out.datasets[1].data.push(pct(sums.neutral, sums.total));
			out.datasets[2].data.push(pct(sums.agree, sums.total));
			out.labels.push([`${cls.course}`, `${cls.term}`]); // [course, desc_term]
		}

		return out;
	}

	// Sort the trend by term label using the terms list order; tie-break by course name
	function orderTrendData(chartData, terms, direction = "asc") {
		const sign = direction === "desc" ? -1 : 1;

		// Build rank map: desc_term -> rank index in requested order
		const termOrder = [...terms].sort((a, b) => (a.term - b.term) * sign).map((t) => t.desc_term);

		const rank = new Map(termOrder.map((name, idx) => [name, idx]));

		const n = chartData.labels.length;
		const idx = Array.from({ length: n }, (_, i) => i).sort((i, j) => {
			const tI = chartData.labels[i]?.[1]; // desc_term
			const tJ = chartData.labels[j]?.[1];
			const rI = rank.has(tI) ? rank.get(tI) : Number.POSITIVE_INFINITY;
			const rJ = rank.has(tJ) ? rank.get(tJ) : Number.POSITIVE_INFINITY;
			if (rI !== rJ) return rI - rJ;

			// tie-break by course name within the same term
			const cI = chartData.labels[i]?.[0] || "";
			const cJ = chartData.labels[j]?.[0] || "";
			return cI.localeCompare(cJ);
		});

		return {
			labels: idx.map((i) => chartData.labels[i]),
			datasets: chartData.datasets.map((ds) => ({ ...ds, data: idx.map((i) => ds.data[i]) })),
		};
	}

	// ---------- main flow ----------
	const terms = await fetchTermsList();

	// Domain choice from master record
	const masterRows = Array.isArray(req_info?.[1]) ? req_info[1] : [];

	// Default (master) point
	const base = buildDefaultDomainDataset(masterRows, domain);

	// Candidates (other classes)
	const comparisonData = await fetchComparisonData(req_info);

	// If trendComparison is not provided, auto-pick up to 4 “similar” rows by course code
	let comparisonRows = [];
	let comparisonIds = Array.isArray(trendComparison) ? [...trendComparison] : null;

	if (!comparisonIds) {
		// Derive a course-key from the master title — prefer the first two tokens if present
		const masterTitle = String(req_info?.[0]?.[0] || "");
		const tokens = masterTitle.trim().split(/\s+/);
		const masterKey = tokens.slice(0, 2).join(" "); // e.g., "PHYSL 210B"

		// Filter by course-key; fall back to first 4 if none match
		const filtered = comparisonData.filter((r) => r.course.includes(masterKey));
		const pool = filtered.length ? filtered : comparisonData;

		// Deduplicate by id and cap at 4
		const seen = new Set();
		comparisonRows = [];
		for (const r of pool) {
			if (seen.has(r.id)) continue;
			seen.add(r.id);
			comparisonRows.push(r);
			if (comparisonRows.length >= 4) break;
		}
		comparisonIds = comparisonRows.map((r) => r.id);
	} else {
		// Use provided ids (in order), include only those present
		const idSet = new Set(comparisonIds);
		comparisonRows = comparisonData.filter((r) => idSet.has(r.id));
	}

	// Build & sort chart data
	const withTrend = calculateTrendStats(base, comparisonRows, domain);
	const trendData = orderTrendData(withTrend, terms, "asc");

	const chartOptions = {
		maintainAspectRatio: false,
		spanGaps: false,
		elements: {
			point: {
				radius: 3, // default 3
				hoverRadius: 6, // bigger on hover
				borderWidth: 3, // ring around the point
				hitRadius: 10, // easier to hover/select
			},
			line: {
				borderWidth: 3, // (optional) line thickness
			},
		},
		plugins: {
			legend: {
				labels: {
					font: { size: 10 },
				},
			},
			title: {
				display: true,
				text: `Trend Analysis of: ${domain}`,
				font: { size: 20, weight: "normal" },
				color: "black",
				padding: { bottom: 20 },
			},
			datalabels: {
				align: "end",
				anchor: "start",
				offset: 10,
				font: {
					weight: "bold", // make text bold
					size: 10, // adjust size if needed
				},
				color: "#000", // label color
				formatter: (value) => `${value}%`, // optional: customize value display
			},
		},
		scales: {
			x: { offset: true },
			y: {
				// beginAtZero: true,
				// afterDataLimits: (axis) => {
				//   // axis.max is what Chart.js calculated
				//   axis.max = Math.ceil(axis.max + 5);
				// },
				min: 0,
				max: 100,
				ticks: {
					stepSize: 20, // interval between ticks (0, 10, 20…)
					callback: (value) => value + "%", // custom label format
				},
			},
		},
	};

	// --- 1) Define your content box in mm (landscape A4: 297 x 210 mm) ---
	const pageW = pdf.internal.pageSize.getWidth(); // 297
	const pageH = pdf.internal.pageSize.getHeight() / 2; // 210

	// Match your header/footer spacing. You draw a header to y=25 and start at 28 elsewhere.
	const marginLeft = 20; // mm
	const marginRight = 20; // mm
	const topAfterHeader = 28; // mm (below the header line you draw)
	const marginBottom = 10; // mm

	const boxWmm = pageW - marginLeft - marginRight;
	const boxHmm = pageH - topAfterHeader - marginBottom;

	// --- 2) Convert mm -> CSS pixels so the canvas matches the PDF box exactly ---
	const QUALITY = 1.25;

	// instead of 96 px per inch, simulate 192 px per inch
	const PX_PER_MM = (96 * QUALITY) / 25.4;
	const boxWpx = Math.round(boxWmm * PX_PER_MM);
	const boxHpx = Math.round(boxHmm * PX_PER_MM);

	// --- 4) Create a fixed-size container DIV in pixels ---
	const container = document.createElement("div");
	container.style.position = "fixed";
	container.style.left = "-10000px"; // keep it off-screen
	container.style.top = "0";
	container.style.width = `${boxWpx}px`;
	container.style.height = `${boxHpx}px`;
	container.style.background = "white"; // ensure non-transparent background
	document.body.appendChild(container);

	// Render the Radar into the fixed-size container
	const chartNode = (
		<div style={{ width: `${boxWpx}px`, height: `${boxHpx}px` }}>
			<Line data={trendData} options={chartOptions} />
		</div>
	);
	ReactDOM.render(chartNode, container);

	// Let layout settle
	await new Promise((r) => setTimeout(r, 1000));

	// --- 5) Snapshot at 1:1 CSS pixel size with html2canvas ---
	const canvas = await html2canvas(container, {
		backgroundColor: "#ffffff",
		scale: 1, // 1 CSS pixel = 1 canvas pixel (we already sized the container)
		useCORS: true,
		logging: false,
	});

	// --- 6) Add the image to PDF, fitting within the mm box and preserving aspect ---
	const imgData = canvas.toDataURL("image/jpeg", 1);
	const props = pdf.getImageProperties(imgData);
	const imgWmmAt1 = props.width / PX_PER_MM;
	const imgHmmAt1 = props.height / PX_PER_MM;
	const imgAspect = imgWmmAt1 / imgHmmAt1;
	const boxAspect = boxWmm / boxHmm;

	let drawWmm, drawHmm;
	if (imgAspect > boxAspect) {
		// Image is wider than the box -> limit by width
		drawWmm = boxWmm;
		drawHmm = drawWmm / imgAspect;
	} else {
		// Image is taller -> limit by height
		drawHmm = boxHmm;
		drawWmm = drawHmm * imgAspect;
	}

	// Center it within the box
	const x = marginLeft + (boxWmm - drawWmm) / 2;
	let y = topAfterHeader + (boxHmm - drawHmm) / 2;

	y = y + (index % 2) * 85;
	pdf.addImage(imgData, "JPEG", x, y, drawWmm, drawHmm);

	// Optional: new page after radar
	// pdf.addPage();

	// --- 7) Clean up ---
	ReactDOM.unmountComponentAtNode(container);
	document.body.removeChild(container);
}

async function displayComments(pdf, req_info, comment_data) {
	await pdfHeader(pdf, req_info);
	let responses = req_info[8];
	let startHeight = 28;
	Object.entries(comment_data).forEach(([index, value]) => {
		let addedHeight = 0;
		const bodyText = [
			[
				{
					content: "Question:",
					styles: {
						fontStyle: "bold",
						fontSize: 8,
						halign: "left",
						valign: "middle",
						textColor: "black",
						cellWidth: 30,
					},
				},
				{
					content: value.q_text,
					styles: {
						fontSize: 8,
						halign: "left",
						valign: "middle",
						textColor: "black",
					},
				},
			],
		];
		addedHeight = addedHeight + 7 + (Math.ceil(value.q_text.length / 210) - 1) * 3;
		if (value.responses[0] === null) {
			bodyText.push([
				{
					content: "Response Rate:",
					styles: {
						fontStyle: "bold",
						fontSize: 8,
						halign: "left",
						valign: "middle",
						textColor: "black",
						cellWidth: 30,
					},
				},
				{
					content: "".concat(calculatePercentage(0, responses), " (", 0, " of ", responses, ")"),
					styles: {
						fontSize: 8,
						halign: "left",
						valign: "middle",
						textColor: "black",
					},
				},
			]);
			bodyText.push([
				{
					content: "No participants responded to this question.",
					colSpan: 2,
					styles: {
						fontStyle: "italic",
						fontSize: 8,
						halign: "center",
						valign: "middle",
						textColor: "red",
					},
				},
			]);
			addedHeight = addedHeight + 7;
		} else {
			bodyText.push([
				{
					content: "Response Rate:",
					styles: {
						fontStyle: "bold",
						fontSize: 8,
						halign: "left",
						valign: "middle",
						textColor: "black",
						cellWidth: 30,
					},
				},
				{
					content: "".concat(
						calculatePercentage(value.responses.length, responses),
						" (",
						value.responses.length,
						" of ",
						responses,
						")",
					),
					styles: {
						fontSize: 8,
						halign: "left",
						valign: "middle",
						textColor: "black",
					},
				},
			]);
			for (let i = 0; i < value.responses.length; i++) {
				if (value.responses[i] !== null) {
					bodyText.push([
						{
							content: value.responses[i],
							colSpan: 2,
							styles: {
								fontSize: 8,
								halign: "left",
								valign: "middle",
								textColor: "black",
							},
						},
					]);
					addedHeight = addedHeight + 7 + (Math.ceil(value.responses[i].length / 210) - 1) * 3;
				}
			}
		}
		if (startHeight + 10 + addedHeight <= 200) {
			autoTable(pdf, {
				body: bodyText,
				startY: startHeight,
				theme: "grid",
			});
		} else {
			if (startHeight > 28) {
				pdf.addPage();
				pdfHeader(pdf, req_info);
			}
			startHeight = 28;
			autoTable(pdf, {
				body: bodyText,
				startY: startHeight,
				theme: "grid",
			});
		}
		startHeight = startHeight + 10 + addedHeight;
	});
	pdf.addPage();
}

const SearchablePDF = async (
	selectedIDs,
	checked,
	filename,
	radarData = null,
	trendComparison = null,
) => {
	const auth = isAuthenticated();
	const token = auth.token;
	const pdf = new jsPDF("landscape", "mm", "a4");
	/* const lastItem = await findLastTrueIndex(checked); */
	const spot_data = await collect_report_data(token, selectedIDs);
	for (let i = 0; i < spot_data.length; i++) {
		let req_info = spot_data[i].req_info;
		let customSpotData = spot_data[i].customSpotData;
		let comments = spot_data[i].comments;

		if (checked[0] === true && req_info[1].length > 1) {
			await standardTable(pdf, req_info[0], req_info[1]);
		}

		if (checked[1] === true && customSpotData.length > 0) {
			await supplementaryTable(pdf, req_info[0], customSpotData);
		}

		if (checked[2] === true && req_info[1].length > 0) {
			await summaryTable(pdf, req_info[0], req_info[1]);
			await summaryChart(pdf, req_info[0], req_info[1]);
		}

		if (checked[4] === true 
			&& Number(sessionStorage.id) === Number(req_info[0][10]) 
			&& req_info[1].length > 0) {
			await radarChart(pdf, req_info, radarData);
		}

		if (checked[5] === true 
			&& Number(sessionStorage.id) === Number(req_info[0][10]) 
			&& req_info[1].length > 0) {
			const spotDomains = [...new Set(req_info[1].map((item) => item.category))];
			// for (const domain of spotDomains) {
			// 	await trendChart(pdf,req_info,trendComparison,domain)
			// };
			for (const [index, domain] of spotDomains.entries()) {
				await trendChart(pdf, req_info, trendComparison, domain, index);
				if (index % 2 !== 0 || index === spotDomains.length - 1) {
					pdf.addPage();
				}
			}
		}

		if (checked[3] === true) {
			await displayComments(pdf, req_info[0], comments.results);
		}

		const last = i === spot_data.length - 1;
		if (last) {
			pdf.deletePage(pdf.getNumberOfPages());
			pdf.save(filename);
		}
	}
};

export { SearchablePDF };
